<template>
  <div class="instructions">
    <BaseSwiper
      ref="swiper"
      :tap-to-continue="true"
      :next-route="nextRoute"
      @slide-change="onSlideChange">
      <template #header>
        <BaseLockup class="lockup"/>
      </template>
      <SwiperSlide>
        <InstructionalVideo
          ref="instructional-video"
          @loaded="onInstructionalVideoLoaded()"
        />
      </SwiperSlide>
      <SwiperSlide v-for="(instruction, i) in media === 'Mobile' ? $content.instructionsMobile : $content.instructionsDesktop" :key="i">
        <Instruction
          :instruction-number="instruction.instructionNumber"
          :text-primary="instruction.textPrimary"
          :text-secondary="instruction.textSecondary"
        />
      </SwiperSlide>
      <template #footer>
        <BaseText2 class="subcopy" text="Tap to continue"/>
      </template>
    </BaseSwiper>
  </div>
</template>

<script>
import BaseLockup from '@/components/BaseLockup/BaseLockup'
import BaseSwiper from '@/components/BaseSwiper/BaseSwiper'
import SwiperSlide from '@/components/BaseSwiper/components/SwiperSlide/SwiperSlide'
import InstructionalVideo from './partials/InstructionalVideo/InstructionalVideo'
import Instruction from './partials/Instruction/Instruction'
import BaseText2 from '@/components/BaseText2/BaseText2'
import getMediaOnLoad from '@/mixins/getMediaOnLoad'
import { TimelineMax, Power1 } from 'gsap'
export default {
  name: 'instructions',
  mixins: [ getMediaOnLoad ],
  components: {
    BaseLockup,
    BaseSwiper,
    SwiperSlide,
    InstructionalVideo,
    Instruction,
    BaseText2
  },
  props: {
    nextRoute: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.tl = this.createTl()
    this.$store.commit('ui/setLoading', true)
  },
  beforeDestroy () {
    this.$store.commit('ui/setLoading', false)
  },
  data () {
    return {
      tls: null,
      instructions: [
        {
          instructionNumber: '01',
          textPrimary: 'Match your<br>opponent’s emotions',
          textSecondary: 'If they get angry. You get angry.'
        },
        {
          instructionNumber: '02',
          textPrimary: 'Timing is everything',
          textSecondary: 'Act fast to match the emotion.'
        },
        {
          instructionNumber: '03',
          textPrimary: 'Raise<br>your phone',
          textSecondary: 'Good lighting can improve your game.'
        },
        {
          instructionNumber: '04',
          textPrimary: 'Turn up the volume',
          textSecondary: 'Get the full staredown experience.'
        },
        {
          instructionNumber: '05',
          textPrimary: 'Get your<br>game face on',
          textSecondary: 'Prepare to face your opponent.'
        }
      ]
    }
  },
  methods: {
    onInstructionalVideoLoaded () {
      this.tl.play()
      this.$store.commit('ui/setLoading', false)
    },
    createTl () {
      const tl = new TimelineMax({ paused: true })
      tl.from(this.$refs['swiper'].$el, 1, { autoAlpha: 0, ease: Power1.easeInOut })
      return tl
    },
    onSlideChange () {
      const component = this.$refs['instructional-video']
      if (component.isPlaying) component.stopVideo()
    }
  }
}
</script>

<style lang="scss" scoped>
.instructions {
  width: 100%;
  height: 100%;
  display: flex;
}
::v-deep .swiper,
::v-deep .swiper-wrapper {
  height: 100%;
}
::v-deep .pagination {
  padding: var(--spacing-1);
  @media #{$media-3} {
    max-width: 40rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
.lockup {
  position: absolute;
  top: var(--spacing-1);
  left: 50%;
  transform: translateX(-50%);
  width: 8.5rem !important;
  margin: auto;
  z-index: 2;
}
.subcopy {
  position: absolute;
  width: 100%;
  bottom: calc(var(--spacing-1) * 2);
  left: 0;
  z-index: 2;
}
.base-text-2 {
  font-size: 0.625rem;
  --letter-spacing: 0.05em;
  letter-spacing: var(--letter-spacing);
}
</style>
